import React from "react";
import "./StudentProfile.css";
import { useEffect, useState } from "react";
import { useUser } from "../../../context/UserContext";
import ShareIcon from '@mui/icons-material/Share';

const StudentProfile = () => {
  const { user } = useUser();
  const studentId = user?.user_id;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");


  //   const referralLink = `http://localhost:3000/#/StudentregReffer/${user.user_id}`;
  //  const copyLink = () => {
  //   navigator.clipboard.writeText(referralLink);
  //   alert("Referral link copied!");
  // };
const referralLink = `http://localhost:3000/#/StudentregReffer/${user.user_id}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Top Faculty",
          text: "Join using my referral link and get 1 hour free video access!",
          url: referralLink
        });
      } catch (err) {
        console.log("Share cancelled");
      }
    } else {
      // fallback for desktop
      window.open(
        `https://wa.me/?text=${encodeURIComponent(referralLink)}`,
        "_blank"
      );
    }
  };


  useEffect(() => {
    if (!studentId) return;

    setLoading(true);

    fetch(
      `https://topfaculty.co.in/api/student_watch_summary.php?stu_id=${studentId}`,
    )
      .then((res) => res.json())
      .then((resData) => {
        if (resData.status) {
          setData(resData);
        } else {
          setError(resData.message || "No data found");
        }
        setLoading(false);
      })
      .catch(() => {
        setError("Server error. Please try again.");
        setLoading(false);
      });
  }, [studentId]);

  if (loading) return <div className="loader">Loading watch summary...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="creative-page">
      {/* Header */}
      <div className="creative-header">
        <h2>
          Hello, <span>{user.user_name}</span>
        </h2>
        <p>Your learning journey at a glance</p>
      </div>

      {/* Floating Profile */}
      <div className="story-stats">
        <div className="profile-glass">
          <img
            src="https://static.vecteezy.com/system/resources/previews/007/477/028/non_2x/icon-male-user-suitable-for-web-interface-symbol-long-shadow-style-simple-design-editable-design-template-simple-symbol-illustration-vector.jpg"
            alt="student"
          />
          <h3>{user.user_name}</h3>
          <span className="tag">Aspirant</span>
        </div>

        <div className="profile-info">
          <div>
            <b>Roll No</b>
            <span>TOPF-{user.user_id}</span>
          </div>
          <div>
            <b>Email</b>
            <span>{user.user_email}</span>
          </div>
          <div>
            <b>Phone</b>
            <span>{user.user_phone}</span>
          </div>
          <div>
            <b>Location</b>
            <span>{user.user_address}</span>
          </div>
        </div>
      </div>

      {/* Story Stats */}
      <div className="story-stats">
        <div className="story-card">
          <h4>⏱️ Learning Time</h4>
          <p>
            5 <span>hrs</span>
          </p>
          <small>Total class watched</small>
        </div>

        <div className="story-card">
          <h4>🎁 Watched Time</h4>
          <p>
            {data.summary.watched} <span>hrs</span>
          </p>
        </div>

        <div className="story-card">
          <h4>👥 Remaining Time</h4>
          <p>
            {data.summary.remaining} <span>hrs</span>
          </p>
        </div>
      </div>

      <div className="story-stats">
        <div className="story-card">
          <h4>⏱️ Learning Time</h4>
          <p>
            5 <span>hrs</span>
          </p>
          <small>Total class watched</small>
        </div>

        <div className="story-card">
          <h4>🎁 Watched Time</h4>
          <p>
            18 <span>hrs</span>
          </p>
          <small>Referral rewards</small>
        </div>

        <div className="story-card">
          <h4>👥 Referrals</h4>
          <p>12</p>
          <small>Friends joined</small>
        </div>

        <div className="story-card highlight share-btn" 
        onClick={handleShare}  style={{ cursor: "pointer" }}
        >
          <h4>🔗 Referral Link</h4>
          <img src="https://cdn-icons-png.flaticon.com/128/2028/2028323.png" alt="Share Icon" style={{ verticalAlign: 'middle', marginRight: '18px',width:'20%' }} />
        </div>

      </div>

      {/* Timeline */}
      {/* <div className="timeline">
        <h3>📌 Student Timeline</h3>

        <div className="timeline-item">
          <span className="dot"></span>
          <p>
            <b>Jan 2025</b> – Joined Vedanta IAS Academy
          </p>
        </div>

        <div className="timeline-item">
          <span className="dot"></span>
          <p>
            <b>Mar 2025</b> – Completed Polity Foundation
          </p>
        </div>

        <div className="timeline-item">
          <span className="dot"></span>
          <p>
            <b>Aug 2025</b> – Started Test Series
          </p>
        </div>
      </div> */}

      <div className="container my-4">
        <div className="watch-wrapper">
          <div className="table-responsive">
            <table className="table watch-table align-middle mb-0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Video Title</th>
                  <th>Watched Date</th>
                  <th>Watched</th>
                  <th className="text-end">Progress</th>
                </tr>
              </thead>

              <tbody>
                {data.videos.length === 0 ? (
                  <tr>
                    <td colSpan="4" style={{ textAlign: "center" }}>
                      No videos watched
                    </td>
                  </tr>
                ) : (
                  data.videos.map((video, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      <td>
                        <span className="watch-link">
                          <a
                            href={video.video_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            ▶ View Video
                          </a>
                        </span>
                      </td>
                      <td className="date-text">{video.watch_date}</td>
                      <td className="date-text">{video.watched_time}</td>

                      <td className="text-end">
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${video.progress_percent}%` }}
                      >
                        {video.progress_percent}%
                      </div>
                    </div>
                  </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentProfile;
